import { Link } from 'react-router-dom';
import { FileText, Hammer, Mail, MapPin, Phone } from 'lucide-react';
import { company, navigation } from '../data/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t-4 border-brand-orange bg-brand-black text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[1.3fr_0.8fr_1fr]">
          <div className="space-y-6">
            <Link to="/" className="inline-flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center bg-brand-orange text-white">
                <Hammer className="h-6 w-6" />
              </div>
              <div className="leading-tight">
                <span className="block font-display text-2xl font-bold tracking-tight text-white">
                  RS <span className="text-brand-orange">BYG</span>
                </span>
                <span className="block text-[10px] font-semibold uppercase tracking-[0.26em] text-brand-gray-400">
                  Tømrerfirma · {company.city}
                </span>
              </div>
            </Link>

            <p className="max-w-md text-sm leading-7 text-brand-gray-400">
              RS Byg udfører alt indenfor tømrerfaget med fokus på kvalitet, godt håndværk og holdbare løsninger i Thisted og omegn.
            </p>

            <div className="flex items-center gap-3 text-sm text-brand-gray-400">
              <FileText className="h-4 w-4 text-brand-orange" />
              <span className="whitespace-nowrap">CVR-nr: {company.cvr}</span>
            </div>
          </div>

          <div className="space-y-6">
            <h2 className="font-display text-lg font-bold uppercase tracking-[0.16em] text-white">
              Hurtige links
            </h2>
            <ul className="space-y-3">
              {navigation.footer.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="text-sm font-medium text-brand-gray-400 transition-colors hover:text-brand-orange">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-6">
            <h2 className="font-display text-lg font-bold uppercase tracking-[0.16em] text-white">
              Kontakt os
            </h2>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="mt-0.5 h-5 w-5 shrink-0 text-brand-orange" />
                <div>
                  <span className="block text-xs uppercase tracking-[0.16em] text-brand-gray-400">Telefon</span>
                  <a href={company.phoneHref} className="text-sm font-bold text-white transition-colors hover:text-brand-orange whitespace-nowrap">
                    {company.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="mt-0.5 h-5 w-5 shrink-0 text-brand-orange" />
                <div>
                  <span className="block text-xs uppercase tracking-[0.16em] text-brand-gray-400">E-mail</span>
                  <a href={company.emailHref} className="text-sm font-bold text-white transition-colors hover:text-brand-orange whitespace-nowrap">
                    {company.email}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-brand-orange" />
                <div>
                  <span className="block text-xs uppercase tracking-[0.16em] text-brand-gray-400">Adresse</span>
                  <span className="text-sm font-medium text-brand-gray-300">{company.address}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 grid gap-4 border-t border-brand-gray-700 pt-8 sm:grid-cols-2 sm:items-center sm:justify-between">
          <p className="text-xs uppercase tracking-[0.18em] text-brand-gray-500">
            &copy; {currentYear} RS Byg. Alle rettigheder forbeholdes.
          </p>
          <p className="text-xs uppercase tracking-[0.18em] text-brand-gray-500 sm:text-right">
            Professionelt tømrerarbejde · Kvalitet · Pålidelighed
          </p>
        </div>
      </div>
    </footer>
  );
}
